const GetUrl = () => {
  const path =
    //eslint-disable-next-line
    window.location != window.parent.location
      ? document.referrer
      : document.location.href;
  return path;
};

export default GetUrl;
